import { atomWithReset } from 'jotai/utils';

// make all of the property with '' to string type
export interface FindIdState {
  step1: {
    value: string;
    firstName: string;
    lastName: string;
    code: string;
  };
  authMethods: any[];
  step2: {
    findWay: string;
    value: string;
  };
  step3: {
    value: string;
    token: string;
    fullPhoneNumber: string;
  };
  loginId: string;
  loginName: {
    first: string;
    last: string;
  };
}

export const state = atomWithReset<FindIdState>({
  step1: {
    value: '',
    firstName: '',
    lastName: '',
    code: '',
  },
  authMethods: [],
  step2: {
    findWay: '',
    value: '',
  },
  step3: {
    value: '',
    token: '',
    fullPhoneNumber: '',
  },
  loginId: '',
  loginName: {
    first: '',
    last: '',
  },
});
